<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManageService()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Service Provider
            </span>
        </div>
    </div>
    <div class="card card_content">
        <div class="cssmtgb just_center">
            <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
                (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Primary Details">
                    <form [formGroup]="form">
                        <div class="row mx-5 d-flex justify-content-center">
                            <div class="col-sm-12 col-md-5 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Service Provider</mat-label>
                                    <input matInput  maxlength="25" formControlName="providerName"
                                        placeholder="Enter Service Provider" required class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-5 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>SP Reference Name</mat-label>
                                    <input matInput  maxlength="25" formControlName="referenceName"
                                        placeholder="Enter SP Reference Name" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-6 mb-3 mt-4">
                                <button type="button" class="btn btn-primary text-nowrap" (click)="addSPContact()">
                                    <i class="fa fa-address-book mr-1"></i> Add Contacts
                                </button>
                            </div>
                        </div>


                        <div class="table-responsive mt-2 mb-4">
                            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                                <ng-container matColumnDef="name">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="name">Contact
                                        Person</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.name}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="mobileNumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="mobileNumber">Contact
                                        Mobile</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.mobileNumber}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="email">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="email">Contact
                                        Email</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.email}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <div class="text-truncate text-center">
                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;"
                                                class="fa fa-edit mr-3" (click)="showEditSPContact(dataField)">
                                            </i>
                                            <!-- (click)="goToManageServiceForm(dataField.id,1)" -->
                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;"
                                                class="fa fa-trash-can" (click)="deleteContact(dataField.id,dataField.name,dataField.contactId)"></i>
                                            <!-- (click)="deleteUser(dataField)" -->
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                </mat-row>
                            </mat-table>
                        </div>

                        <div class="table_pagenation">
                            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>

                        <div class="d-flex justify-content-end button-style mt-1">
                            <button class="btn btn-primary mb-3 mr-3" type="button" (click)="goToManageService()"
                                matButton>Cancel</button>
                            <button class="btn btn-secondary mb-3" type="submit" (click)="onsubmit()"
                                matButton>Save</button>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Target">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-3 mt-4">
                            <button type="button" class="btn btn-primary text-nowrap" (click)="addSPTarget()">
                                <i class="fa fa-address-book mr-1"></i> Add Target
                            </button>
                        </div>
                    </div>

                    <div class="table-responsive mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSourceT" matSort matSortDirection="asc">

                            <ng-container matColumnDef="targetCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="targetCount">Target/Connection
                                    Count</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <p class="text-truncate txtalign">{{dataField.targetCount}}</p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="effectiveFrom">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="effectiveFrom">Effective
                                    From</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <p class="text-truncate txtalign">{{dataField.effectiveFrom | date:'MMM/yyyy'}}</p>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumnsT; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumnsT;" matRipple>
                            </mat-row>
                        </mat-table>
                    </div>

                    <div class="table_pagenation">
                        <mat-paginator #paginator [length]="dataSourceT!==null && dataSourceT.filteredData.length"
                            [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                        </mat-paginator>
                    </div>

                    <div class="d-flex justify-content-end button-style mt-1">
                        <button class="btn btn-primary mb-3 mr-3" type="button" (click)="goToManageService()"
                            matButton>Cancel</button>
                        <button class="btn btn-secondary mb-3" type="submit" (click)="onsubmit()"
                            matButton>Save</button>
                    </div>
                </mat-tab>
                <mat-tab label="SLA">
                    <form [formGroup]="slaForm">
                        <div class="row mt-4 input_height_custom">
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center" >
                                        <mat-checkbox (change)="setNull($event,'approvalStateTimeInterval')"formControlName="isApprovalState" color="primary">New
                                            Application to Approval State</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25" type="number" min="0"
                                                formControlName="approvalStateTimeInterval" placeholder="SLA Time(Hrs)"
                                                class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isApprovalState">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'completedStateTimeInterval')" formControlName="isCompletedState" color="primary">New
                                            New Application to Completed State</mat-checkbox>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25" type="number" min="0"
                                                formControlName="completedStateTimeInterval" placeholder="SLA Time(Hrs)"
                                                class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isCompletedState">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'spRequestedTimeInterval')" formControlName="isSPRequested" color="primary">New
                                            Approval to SP Requested</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25"
                                                formControlName="spRequestedTimeInterval" placeholder="SLA Time(Hrs)"
                                                type="number" min="0" class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isSPRequested">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'spConfrimedTimeInterval')" formControlName="isSPConfrimed" color="primary">
                                            SP Requested to SP Confirmed</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25"
                                                formControlName="spConfrimedTimeInterval" placeholder="SLA Time(Hrs)"
                                                type="number" min="0" class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isSPConfrimed">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'deviceAllocationTimeInterval')" formControlName="isDeviceAllocation" color="primary">
                                            SP Confirmed to Device Allocation</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25" type="number" min="0"
                                                formControlName="deviceAllocationTimeInterval"
                                                placeholder="SLA Time(Hrs)" class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isDeviceAllocation">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'dispatchTimeInterval')" formControlName="isDispatch" color="primary">
                                            Device Allocation to Dispatch</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25"
                                                formControlName="dispatchTimeInterval" placeholder="SLA Time(Hrs)"
                                                type="number" min="0" class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isDispatch">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-3">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 align-self-center">
                                        <mat-checkbox (change)="setNull($event,'toBeBilledTimeInterval')" formControlName="isToBeBilled" color="primary">
                                            Dispatch to Completed / To be Billed</mat-checkbox>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <input matInput  maxlength="25" type="number" min="0"
                                                formControlName="toBeBilledTimeInterval" placeholder="SLA Time(Hrs)"
                                                class="col-10" autocomplete="off"
                                                [readonly]="!this.slaForm.value.isToBeBilled">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="d-flex justify-content-end button-style mt-1">
                        <button class="btn btn-primary mb-3 mr-3" type="button" (click)="goToManageService()"
                            matButton>Cancel</button>
                        <button class="btn btn-secondary mb-3" type="submit" (click)="onsubmit()"
                            matButton>Save</button>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
